import ManualAcceptanceDialog from './ManualAcceptanceDialog';

export default ManualAcceptanceDialog;
